import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EstadoRevisionInformacionBancariaDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class EstadoRevisionInformacionBancariaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getEstadoRevisionInformacionBancariaService(): Observable<BodyListResponse<EstadoRevisionInformacionBancariaDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionInformacionBancariaDTO>>(API_URL + '/api/v1/estadoRevisionInformacionBancaria/todos');
  }

  guardarEstadoRevisionInformacionBancariaService(estadoRevisionInformacionBancariaDTO: EstadoRevisionInformacionBancariaDTO): Observable<EstadoRevisionInformacionBancariaDTO> {
    return this.http.post<EstadoRevisionInformacionBancariaDTO>(API_URL + '/api/v1/estadoRevisionInformacionBancaria', estadoRevisionInformacionBancariaDTO);
  }

  getEstadoRevisionInformacionBancariaPorCodigoRevisionInformacionBancariaService(codigoRevisionInformacionBancaria: string): Observable<BodyResponse<EstadoRevisionInformacionBancariaDTO>> {
    return this.http.get<BodyResponse<EstadoRevisionInformacionBancariaDTO>>(API_URL + '/api/v1/estadoRevisionInformacionBancaria/' + codigoRevisionInformacionBancaria);
  }

  
  getEstadoRevisionInfoBancariaPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<EstadoRevisionInformacionBancariaDTO>> {
      return this.http.get<BodyListResponse<EstadoRevisionInformacionBancariaDTO>>(API_URL + '/api/v1/estadoRevisionInformacionBancaria/persona/'+codigoPersona);
   }
}
